import { CriteriaController } from "@js/controllers/CriteriaController";
import { AuthService } from "@js/services/AuthService";
import { SharedCriteriaService } from "@js/services/Deal/SharedCriteriaService";
import { OrganisationService } from "@js/services/OrganisationService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import { EnterpriseService } from "@js/services/EnterpriseService";
import {
  ApplicationUser,
  ApplicationUserCrudClient,
  BrickflowEventLogClient,
  CaseStatusEnum,
  Client,
  CommercialDeal,
  CommercialDealClient,
  DealClient,
  DealSourceTypeEnum,
  LinkSourceTypeEnum,
  LinkTypeEnum,
  LoanRepaymentTypeEnum,
  LocationEnum,
  Organisation,
  OrganisationClient,
  OrganisationLinkClient,
  OriginatorRoleTypeEnum,
  OwnOrPurchaseEnum,
  ProductFamilyEnum,
  ProductTypeEnum,
  SaveCommercialSearchRequest,
  SaveSearchReturnUniqueRefResponse,
  ShareDealDTO,
  StaticDataClient,
  UserClient,
  UserRoleEnum,
  YesNoMaybe,
} from "@src/apis/ModularClient";
import CommercialDealHelper from "@js/helpers/CommercialDealHelper";
import DealHelper from "@js/helpers/DealHelper";
import { UserService } from "@js/services/UserService";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class CommercialCriteriaController extends CriteriaController<CommercialDeal> {
  dealDto: CommercialDeal;
  tempDealDto: CommercialDeal;
  snapshotDealDto: CommercialDeal;
  productType: ProductTypeEnum;

  maxPurchaseDate: Date = new Date();
  minPurchaseDate: Date = new Date("Jan 01 1900");
  isLoggedInUser: boolean = false;
  // dataLoading: boolean = false;
  isSearchStarted: boolean = false;
  hasError: boolean = false;
  mortgageTerm: number = 0;

  multiPartForm1: ng.IFormController;

  //Share a search modal
  showShareSearchtoClientModal: boolean = false;
  existingborrower: boolean;

  //Message to show when Enterprise url does not have valid lead gen license status or whitelabel add on is not paid or whitelabel setting is not on.
  noPermissionErrorMsg: string = "";

  //Enterprise user clientId
  clientId: number = null;
  enterpriseUser: ApplicationUser = null;

  currentUseofBuildingOptions = [];
  locationOptions = [];
  borrowingEntityTypeOptions = [];

  hasPurchasecostChanged: boolean = false;

  guidanceCheckbox: boolean = true;
  //shows the selected existing client data on share modal

  isDeal: boolean = true;

  isBorrower: boolean = false;
  organisation: Organisation;
  moveContactBrokerBtnInMiddle: boolean = false;
  initialRegistrationClient: Client;
  orgCode: string = "";

  isAdmin: boolean = false;
  isBroker: boolean = false;
  isLender: boolean = false;

  isCommercialOwnerOccupiedActive: boolean = false;
  showAutofill: boolean = false;
  isSubmitted: boolean = false;

  //enterprise widget journey
  isMobileView: boolean = false;
  enterpriseLinkLogo: string;
  showHelpModal: boolean = false;
  loanInfoText: string;
  progressAmount: string = "50%";
  progressSection: number = 1;
  totalSections: number = 3;
  loanRepaymentTypeOptions = [];
  fixedrateTermOptions = [];
  loanCompletionTypeOptions = [];
  productTypeOptions = [];
  timeLeftOnLeaseOptions = [];

  isWidget: boolean = false;
  //This propert is used to show only postcode ot location field on critera for mobile view
  isCriteria: boolean = true;

  error: string;
  showAdjustedAnnualEBITDAHelpertext: boolean = false;

  //orgLinkId: number = null;
  orgLinkSourceType: LinkSourceTypeEnum;

  //Helper text link
  showBridgingLink: boolean;
  static $inject = [
    "$scope",
    "$rootScope",
    "$routeParams",
    "$cookies",
    "$location",
    "$q",
    "UserService",
    "UserClient",
    "RoleService",
    "OrganisationService",
    "OrganisationClient",
    "SelectListService",
    "CommercialDealClient",
    "SharedCriteriaService",
    "BrickflowEventLogClient",
    "AuthService",
    "OrganisationLinkClient",
    "DealClient",
    "EnterpriseService",
    "StaticDataClient",
    "ODataHelper",
    "ApplicationUserCrudClient",
  ];

  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    $routeParams: ng.route.IRouteParamsService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
    protected $q: ng.IQService,
    private userService: UserService,
    userClient: UserClient,
    private roleService: RoleService,
    private organisationService: OrganisationService,
    private organisationClient: OrganisationClient,
    private selectListService: SelectListService,
    private commercialDealClient: CommercialDealClient,
    sharedCriteriaService: SharedCriteriaService,
    eventLogClient: BrickflowEventLogClient,
    private $auth: AuthService,
    organisationLinkClient: OrganisationLinkClient,
    dealService: DealClient,
    private enterpriseService: EnterpriseService,
    private staticDataClient: StaticDataClient,
    odataHelper: ODataHelper,
    applicationUserCrudClient: ApplicationUserCrudClient,
  ) {
    super(
      dealService,
      $routeParams,
      odataHelper,
      organisationLinkClient,
      sharedCriteriaService,
      applicationUserCrudClient,
      userClient,
      eventLogClient,
    );
    this.init();
  }

  async init() {
    try {
      if (this.$routeParams.linkId) {
        this.orgLinkId = Number(this.$routeParams.linkId);
      }

      if (this.$routeParams.context == "widget") {
        if (window.self != window.top) {
          this.isWidget = true;
        } else {
          this.noPermissionErrorMsg =
            "This URL is designed to be embedded into a site, as a widget. If you would like the user to access this search directly, please use an Enterpise link.";
        }
      } else {
        if (window.innerWidth <= 480) this.isMobileView = true;
      }

      if (!this.$cookies.get("access_token") && this.isValidEnterprisePath()) {
        if (window.self == window.top) {
          this.orgCode = this.$cookies.get("org_code") ?? null;
        } else {
          this.orgCode = location.pathname.replace("/", "");
        }

        if (this.$routeParams.uniqueId) {
          await this.getProductFamiliesByUniqueId();
        }

        await this.getEnterpriseOrganisationByOrgCode();

        if (this.orgLinkId === null || this.orgLinkId === undefined || this.orgLinkId === 0) {
          await this.getEnterpriseLinkId();
        }

        if (this.orgLinkId !== null || this.orgLinkId !== undefined || this.orgLinkId === 0) {
          this.organisationLinkClient.getLinkSourceType(this.orgLinkId).then((linkSourceType: LinkSourceTypeEnum) => {
            if (linkSourceType !== null && linkSourceType !== undefined) {
              this.orgLinkSourceType = linkSourceType;
            } else {
              this.noPermissionErrorMsg = "We are unable to compare loans right now.  Please contact your broker.";
              return;
            }
          });
        }
      }

      this.staticDataClient.isCommercialOwnerOccupiedActive().then((response) => {
        this.isCommercialOwnerOccupiedActive = response;
      });

      //Initial data setup for a commercial deal
      if (this.dealDto == null) {
        this.dealDto = {} as CommercialDeal;
      }

      //Enteprise journey code
      if (!this.$cookies.get("access_token") && this.isValidEnterprisePath()) {
        this.isBorrower = true;
        if (this.$location.path().startsWith("/e/commercialcriteria")) {
          var imgs = document.getElementsByTagName("img");
          this.enterpriseLinkLogo = imgs[0].src;
          //this.sharedCriteriaService.storeEnterpriseLinkType(LinkTypeEnum.Commercial.toString());
          this.sharedCriteriaService.setPreviousUrl(this.$location.absUrl());
        }

        if (this.isWidget) {
          //document.getElementById("footer").style.display = "none";
          this.organisationService.sendDataToParent("height", "745px");
        }

        if (!this.$routeParams.DealUniqueRef || this.$routeParams.DealUniqueRef == "0") {
          if (window.self == window.top) {
            this.orgCode = this.$cookies.get("org_code") ?? null;
            sessionStorage.setItem("userRole", UserRoleEnum.Client.toString());
          } else {
            this.orgCode = location.pathname.replace("/", "");
            this.organisationService.sendDataToParent("userRole", UserRoleEnum.Client.toString());
          }

          this.logEventWithoutDealData();
        }
      }

      if (window.self == window.top && this.$cookies.get("access_token")) {
        this.isLoggedInUser = true;

        this.userClient.getCurrentUserAutofill().then((response) => {
          this.showAutofill = response;
        });

        this.roleService
          .GetUserRoles()
          .then((result) => {
            if (result.filter((x) => x.toLowerCase() == "admin").length > 0) {
              this.isAdmin = true;
            }
            if (result.filter((x) => x.toLowerCase() == "broker").length > 0) {
              this.isBroker = true;
              if (!this.isAdmin)
                if (this.isBroker) {
                  //This block is to navigate a broker to userdashboard when they do not have a license.
                  if (sessionStorage.getItem("isValidLicense") == "false") {
                    this.gotoDashboard();
                  }
                }
            }
            if (result.filter((x) => x.toLowerCase() == "lender").length > 0 && !this.isAdmin) {
              this.isLender = true;
            }

            if (result.filter((x) => x.toLowerCase() == "client").length > 0 && !this.isAdmin) {
              this.isBorrower = true;
            }
          })
          .finally(() => {
            if (this.$auth.getHasValidStatustoShowShareSearchModal()) {
              if (sessionStorage.getItem("skip")) {
                //This will hide's a share search to client modal
                this.showShareSearchtoClientModal = false;
              } else {
                //getting a previously entered DealName and Client data
                if (DealHelper.getShowSearchNameAndUserSelectionModal()) {
                  this.showShareSearchtoClientModal = true;
                  this.getUsersBelongToBrokerOrAdmin();
                } else {
                  this.shareDealDto.clientDto = DealHelper.getClient();
                  this.shareDealDto.dealName = DealHelper.getDealName();
                }
              }
            }
            this.getOriginatorInfoForUser();
          });
      } else {
        if (!this.$routeParams.DealUniqueRef || this.$routeParams.DealUniqueRef == "0") {
          if (window.self == window.top) {
            this.clientId = Number(sessionStorage.getItem("clientId"));
          } else {
            Promise.all([
              this.organisationService.getData("clientId").then((clientId) => {
                if (clientId) {
                  this.clientId = Number(clientId);
                }
              }),
            ]);
          }
        }
      }

      if (this.$routeParams.DealUniqueRef && this.$routeParams.DealUniqueRef != "0") {
        this.dataLoading = true;
        this.dealService
          .fetchByUniqueRef(this.$routeParams.DealUniqueRef)
          .then((response) => {
            this.postRetrieveProcessing(response);
          })
          .finally(() => {
            this.dataLoading = false;
          });
      } else if (this.$routeParams.SearchId > 0) {
        this.dataLoading = true;
        this.commercialDealClient
          .fetch(this.$routeParams.SearchId)
          .then((response) => {
            this.postRetrieveProcessing(response);
          })
          .finally(() => {
            this.dataLoading = false;
          });
      } else {
        this.dealDto.maxLoanRequired = true;
        this.dealDto.showLenderInfoBrokerOverride = true;
        this.commercialTypeChanged(ProductTypeEnum.CommercialInvestment);
      }

      if (window.self == window.top) {
        this.updateGuidanceState();

        this.$rootScope.$on("guidanceStateChanged", (event: ng.IAngularEvent) => {
          this.updateGuidanceState();
        });
      }

      this.locationOptions = this.selectListService.GetLocations();
      this.borrowingEntityTypeOptions = this.selectListService.GetBorrowingEntityTypeOptions(
        ProductTypeEnum.CommercialOwnerOccupied,
      );
      //iFrame agent
      this.loanRepaymentTypeOptions = this.selectListService.GetLoanRepaymentTypeOptions();
      this.fixedrateTermOptions = this.selectListService.GetFixedRateTermOptions();
      this.loanCompletionTypeOptions = this.selectListService.GetLoanCompletionOptions();
      this.productTypeOptions = this.selectListService.GetInterestRateType();
      this.timeLeftOnLeaseOptions = this.selectListService.GetTimeLeftOnLeaseOptions();
    } catch (e) {
      console.error("Error: ", e);
    }
  }

  async getEnterpriseOrganisationByOrgCode() {
    await this.organisationClient
      .getOrgByUrlIfOrgHasEnterpriseSearchPermission(
        this.orgCode,
        ProductFamilyEnum.Commercial,
        this.orgLinkId !== null ? this.orgLinkId.toString() : null,
      )
      .then((response) => {
        if (response) {
          this.organisation = response;
          this.orgCode = response.organisationCode;

          if (this.orgLinkId) {
            if (this.$location.path().startsWith("/e/commercialcriteria")) {
              this.organisationLinkClient
                .getOrganisationLinkLogoByLinkIdAndLogPageLoadEvent(this.orgLinkId, "", 0, ProductTypeEnum.None, "", 0)
                .then((logoUrl) => {
                  const imgs = document.getElementsByTagName("img");
                  if (logoUrl != null && logoUrl.length > 0) this.enterpriseLinkLogo = imgs[0].src = logoUrl;
                });
            }
          }
        } else {
          this.logEvent("COMMERCIALCRITERIA-NO-PERMISSION-TO-SEARCH");
          this.noPermissionErrorMsg = "We are unable to compare loans right now.  Please contact your broker.";
        }
      });
  }

  async getEnterpriseLinkId() {
    const linkType = this.$location.path().startsWith("/allloans") ? LinkTypeEnum.AllLoans : LinkTypeEnum.Commercial;

    try {
      // This is an enterprise link without an org link ID, so look up the ID
      await this.organisationLinkClient.getEnterpriseLinkId(this.organisation.id, linkType).then((linkId) => {
        if (linkId !== null || linkId !== undefined || linkId !== 0) {
          this.orgLinkId = linkId;
        } else {
          this.noPermissionErrorMsg = "We are unable to compare loans right now.  Please contact your broker.";
          return;
        }
      });
    } catch (err) {
      this.noPermissionErrorMsg = "We are unable to compare loans right now.  Please contact your broker.";
      return;
    }
  }

  getRequiredRoles(isCaseDashboard: boolean) {
    if (isCaseDashboard) return `['Admin', 'Client', 'Broker', 'Introducer']`;
    return `['Admin', 'Client', 'Broker', 'Introducer', 'Lender']`;
  }

  updateGuidanceState() {
    this.guidanceCheckbox = this.$cookies.get("guidance") === "on" || this.$cookies.get("guidance") === undefined;
  }

  //Clears the previously selected existing client data on share search modal
  clearInputFields() {
    this.shareDealDto = this.sharedCriteriaService.clearExistingUserOnShareDealDto(this.shareDealDto);
    this.showClientDetails = false;
  }

  getUsersBelongToBrokerOrAdmin() {
    this.userClient
      .getUserSummariesForBrokerOrAdmin()
      .then((response) => {
        this.existingUsers = response;
      })
      .finally(() => {});
  }

  gotoDashboard() {
    this.$auth.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  //new search share modal close btn function
  OnClickOfSkip() {
    this.showShareSearchtoClientModal = false;
    this.shareDealDto.clientDto = null;
    if (this.$location.path().startsWith("/allloans") && (this.isAdmin || this.isBroker)) {
      DealHelper.setShowSearchNameAndUserSelectionModal(false);
    }
  }

  //new search share modal next btn function
  onClickOfNext() {
    this.showShareSearchtoClientModal = false;
    if (this.$location.path().startsWith("/allloans") && (this.isAdmin || this.isBroker)) {
      DealHelper.setShowSearchNameAndUserSelectionModal(false);
      DealHelper.setClient(this.shareDealDto.clientDto);
      DealHelper.setDealName(this.shareDealDto.dealName);
    }
  }

  // End of Share a modal functions

  goToLoanSelectionOptions() {
    this.$auth.setHasValidStatustoShowShareSearchModal(true);
    this.$location.path("/allloans");
  }

  calculatePurchaseOrLandCost() {
    if (this.dealDto.purchasePrice && !this.hasPurchasecostChanged) {
      this.dealDto.purchaseCosts = (this.dealDto.purchasePrice * 5) / 100;
    }
  }

  datasetupOnOwnOrPurchaseChange() {
    this.dealDto = CommercialDealHelper.datasetupOnOwnOrPurchaseChange(this.dealDto);
  }

  datasetupOnMaxLoanRequiredChange() {
    this.dealDto = DealHelper.dataSetupOnMaxLoanRequiredChange(this.dealDto);
  }

  onOwnOrPurchaseChange(OwnOrPurchase: boolean) {
    this.dealDto.ownOrPurchase = this.dealDto.hasOwnOrPurchase ? OwnOrPurchaseEnum.Own : OwnOrPurchaseEnum.Purchasing;
    this.datasetupOnOwnOrPurchaseChange();
  }

  onCurrentUseOfBuilding() {
    if (this.dealDto.productType == ProductTypeEnum.CommercialInvestment) {
      this.dealDto = CommercialDealHelper.datasetupOnCurrentUseOfBuilding(this.dealDto);
    }
  }

  onIsFamilyInResidenceChange() {
    this.dealDto.isFamilyInResidence = this.dealDto.hasIsFamilyInResidence ? YesNoMaybe.Yes : YesNoMaybe.No;
  }

  initialDataSetupForIsFamilyInResidence() {
    if (this.dealDto.hasIsFamilyInResidence) {
      this.dealDto.isFamilyInResidence = YesNoMaybe.Yes;
      this.dealDto.hasIsFamilyInResidence = true;
    } else {
      this.dealDto.isFamilyInResidence = YesNoMaybe.No;
      this.dealDto.hasIsFamilyInResidence = false;
    }
  }

  async logEvent(identifier: string) {
    var orgCode;
    if (window.self == window.top) {
      if (sessionStorage.getItem("clientId")) {
        this.eventLogClient.logPageLoad(
          identifier,
          this.orgCode,
          "",
          "Client",
          this.dealDto?.organisationLinkId,
          this.dealDto.productType,
          "",
          this.dealDto.id,
          Number(sessionStorage.getItem("clientId")),
        );
      } else {
        this.eventLogClient.logPageLoad(
          identifier,
          this.orgCode,
          "",
          "Client",
          this.dealDto?.organisationLinkId,
          this.dealDto.productType,
        );
      }
    } else {
      var clientId: number = null;
      clientId = Number(await this.organisationService.getData("clientId"));
      if (clientId) {
        this.eventLogClient.logPageLoad(
          identifier,
          this.orgCode,
          "",
          "Client",
          this.dealDto.organisationLinkId,
          this.dealDto.productType,
          "",
          this.dealDto.id,
          clientId,
        );
      } else {
        this.eventLogClient.logPageLoad(
          identifier,
          this.orgCode,
          "",
          "Client",
          this.dealDto.organisationLinkId,
          this.dealDto.productType,
        );
      }
    }
  }

  goToSearchResults() {
    this.isSubmitted = true;
    this.isSearchStarted = true;
    this.hasError = false;
    this.error = null;
    // If enterprise
    if (!this.isLoggedInUser && this.isBorrower && this.isValidEnterprisePath()) {
      this.enterpriseService.setProductFamily(this.dealDto.productFamily);

      this.saveCriteriaReturnUniqueRef().then((response) => {
        if (!this.hasError) {
          this.sharedCriteriaService.setIsDataLoading(false);
          var uniqueRef = response as SaveSearchReturnUniqueRefResponse;
          if (window.self == window.top) sessionStorage.removeItem("productType");
          if (response.hasDealClient) {
            //The purpose of the route check is to ensure navigation to the correct route when the user lands on the criteria page by clicking 'Change Search' in the side panel.
            if (sessionStorage.getItem("previousRoute") == "referredsearchdeal") {
              this.$location.path(`/referredsearchdeal/${response.dealClientUniqueRef}/false`);
              sessionStorage.removeItem("previousRoute");
            } else {
              this.$location.path(`/e/commercialresults/${response.dealUniqueRef}`);
            }
          } else {
            var leadCaptureUrl = `/e/enterpriseleadcapture/${response.dealUniqueRef}`;
            leadCaptureUrl = this.isWidget ? `${leadCaptureUrl}/widget` : leadCaptureUrl;

            this.$location.path(leadCaptureUrl);
          }
        }
      });
    } else {
      this.saveCriteriaReturnId().then((response) => {
        if (!this.hasError) {
          var dealId = response as number;
          if (window.self == window.top) sessionStorage.removeItem("productType");
          if (this.isAdmin || this.isBroker) DealHelper.setShowSearchNameAndUserSelectionModal(true);
          this.$location.path("/commercialresults/" + dealId);
        }
      });
    }
  }

  searchDisabled() {
    if (!this.dealDto) return true;

    if (this.progressSection == 1) {
      this.progressAmount = "0%";

      if (
        this.dealDto.isFamilyInResidence == 1 ||
        this.dealDto.locations == null ||
        this.dealDto.locations <= 0 ||
        this.showPostcodeErrorMessage
      ) {
        return true;
      }

      if (this.multiPartForm1.$invalid) {
        return true;
      }

      this.progressAmount = "33%";
    }

    if (this.progressSection == 2) {
      this.progressAmount = "33%";

      if (
        this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Purchasing &&
        (this.dealDto.purchasePrice == null || this.dealDto.purchasePrice == 0)
      ) {
        return true;
      }

      if (
        this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Own &&
        (this.dealDto.currentvalue == null || this.dealDto.currentvalue == 0)
      ) {
        return true;
      }

      if (this.dealDto.isFamilyInResidence == 1 || this.hasValidNetLoanRequiredValue()) {
        return true;
      }

      if (this.multiPartForm1.$invalid) {
        return true;
      }

      this.progressAmount = "66%";
    }

    if (this.progressSection == 3) {
      this.progressAmount = "66%";

      if (this.multiPartForm1.$invalid) {
        return true;
      }

      this.progressAmount = "100%";
    }

    return false;
  }

  saveCriteriaReturnId(): ng.IPromise<number> {
    let defer = this.$q.defer<number>();

    this.dataSetUpForSave();

    var clientDto = null;
    /* if (!this.isLoggedInUser && this.enterpriseUser && (this.$location.path().startsWith("/e/commercialcriteria") || this.$location.path().startsWith("/allloans"))) {
                clientDto = this.sharedCriteriaService.setClientDtoDataForEnterpriseSearch(this.enterpriseUser, this.brokerageOrg.Id, clientDto);
            }*/

    var request: SaveCommercialSearchRequest = {
      deal: this.dealDto,
      shareDealDto: this.shareDealDto,
      orgCode: this.isLoggedInUser ? "" : this.orgCode,
      clientId:
        !this.isLoggedInUser && this.clientId && !this.enterpriseUser && this.isValidEnterprisePath()
          ? Number(this.clientId)
          : 0,
      enterpriseClientDto: clientDto,
    };

    this.commercialDealClient
      .saveCommercialSearchReturnsId(request)
      .then((response) => {
        this.dealDto.id = response;

        defer.resolve(response as number);
        return response;
      })
      .catch((response) => {
        defer.reject(response);
        if (response.status === 500) {
          this.error = response.data.message;
        } else {
          this.error = "Something went wrong while searching for loans. Please try again.";
        }
        this.hasError = true;
        this.isSearchStarted = false;
      });

    return defer.promise;
  }

  saveCriteriaReturnUniqueRef(): ng.IPromise<SaveSearchReturnUniqueRefResponse> {
    let defer = this.$q.defer<SaveSearchReturnUniqueRefResponse>();
    this.sharedCriteriaService.setIsDataLoading(true);

    this.dataSetUpForSave();

    var clientDto = null;
    /* if (!this.isLoggedInUser && this.enterpriseUser && (this.$location.path().startsWith("/e/commercialcriteria") || this.$location.path().startsWith("/allloans"))) {
                clientDto = this.sharedCriteriaService.setClientDtoDataForEnterpriseSearch(this.enterpriseUser, this.brokerageOrg.Id, clientDto);
            }*/

    const request: SaveCommercialSearchRequest = {
      deal: this.dealDto,
      shareDealDto: this.shareDealDto,
      orgCode: this.isLoggedInUser ? "" : this.orgCode,
      clientId:
        !this.isWidget && !this.isLoggedInUser && this.clientId && !this.enterpriseUser && this.isValidEnterprisePath()
          ? Number(this.clientId)
          : 0,
      enterpriseClientDto: clientDto,
      sourceUrl: this.isLoggedInUser ? "" : this.sharedCriteriaService.getPreviousUrl(),
    };

    this.commercialDealClient
      .saveCommercialSearchReturnsUniqueRef(request)
      .then((response) => {
        this.dealDto.uniqueRef = response.dealUniqueRef;

        defer.resolve(response as SaveSearchReturnUniqueRefResponse);
        return response;
      })
      .catch((response) => {
        defer.reject(response);
        this.sharedCriteriaService.setIsDataLoading(false);
        if (response.status === 500) {
          this.error = response.data.message;
        } else {
          this.error = "Something went wrong while searching for loans. Please try again.";
        }
        this.hasError = true;
        this.isSearchStarted = false;
      });

    return defer.promise;
  }

  dataSetUpForSave() {
    this.sharedCriteriaService.setNewSearch(this.dealDto, this.snapshotDealDto);

    if (this.dealDto.id == null) {
      this.dealDto.status = CaseStatusEnum.Search;
    }

    if (this.dealDto.name == null || this.dealDto.name == "" || this.dealDto.name == undefined) {
      this.dealDto.name = this.sharedCriteriaService.defaultSearchName(this.dealDto.productType);
    }

    if (!this.isLoggedInUser && this.isValidEnterprisePath() && this.isBorrower) {
      this.dealDto.howManyFlats = this.dealDto.howManyFlats ? this.dealDto.howManyFlats : 0;
      this.dealDto.howManyHouses = this.dealDto.howManyHouses ? this.dealDto.howManyHouses : 0;
    }

    if (!this.shareDealDto) {
      this.shareDealDto = {
        dealName: this.sharedCriteriaService.defaultSearchName(this.dealDto.productType),
      } as ShareDealDTO;
    } else {
      if (this.shareDealDto && this.shareDealDto.clientDto) {
        this.shareDealDto.clientDto.postalAddress = this.shareDealDto.clientDto.postalAddress ?? {
          addressLine1: "",
          addressLine2: "",
          addressLine3: "",
          addressLine4: "",
          postCode: "",
        };
        this.shareDealDto.clientDto.id = this.shareDealDto.clientDto.id ?? 0;
      }
    }

    if (this.dealDto.purchasePrice == null) {
      this.dealDto.purchasePrice = 0;
    }

    if (this.dealDto.purchaseCosts == null) {
      this.dealDto.purchaseCosts = 0;
    }
  }

  dummysearch() {
    if (this.dealDto.hasPostcode) {
      this.dealDto.postcodeSearchString = this.sharedCriteriaService.getRandomPostcode();
      this.getRegionByPostcode();
    } else {
      this.dealDto.locations = LocationEnum.London;
    }

    this.mortgageTerm = this.sharedCriteriaService.getRandomIntInclusive(10, 30);
    this.mortgageTermToLoanTerm();
    this.dealDto.maxLoanRequired = this.sharedCriteriaService.getRandomIntInclusive(0, 1) == 1 ? true : false;
    if (!this.dealDto.maxLoanRequired) {
      this.dealDto.netLoanRequired = this.sharedCriteriaService.getRandomIntInclusive(400000, 2000000);
    }

    if (this.dealDto.productType == ProductTypeEnum.CommercialInvestment) {
      this.dealDto.grossMonthlyRentalIncome = this.sharedCriteriaService.getRandomIntInclusive(10000, 20000);
    } else {
      this.dealDto.adjustedAnnualEBITDA = this.sharedCriteriaService.getRandomIntInclusive(500000, 1000000);
    }

    this.dealDto.purchasePrice = this.sharedCriteriaService.getRandomIntInclusive(5000000, 10000000);
    this.dealDto.purchaseCosts = this.sharedCriteriaService.getRandomIntInclusive(100000, 1000000);
  }

  initMortgageTerm() {
    this.dealDto.loanTermReq = this.dealDto.loanTermReq || 240;
    this.mortgageTerm = this.dealDto.loanTermReq / 12;
  }

  mortgageTermToLoanTerm() {
    this.dealDto.loanTermReq = this.mortgageTerm * 12;
  }

  onLoanRepaymentTypeChange() {
    if (this.dealDto.loanRepaymentType == LoanRepaymentTypeEnum.Repayment) {
      this.mortgageTerm = 20;
    } else if (this.dealDto.loanRepaymentType == LoanRepaymentTypeEnum.InterestOnly) {
      this.mortgageTerm = 10;
    }
    this.mortgageTermToLoanTerm();
  }

  hasValidNetLoanRequiredValue() {
    if (
      !this.dealDto.maxLoanRequired &&
      (this.dealDto.netLoanRequired == null || isNaN(this.dealDto.netLoanRequired) || this.dealDto.netLoanRequired <= 0)
    ) {
      return true;
    } else {
      return false;
    }
  }

  getRegionByPostcode() {
    if (this.dealDto.postcodeSearchString && this.dealDto.postcodeSearchString.replace(" ", "").length >= 2) {
      if (DealHelper.isValidPostcodeString(this.dealDto.postcodeSearchString)) {
        this.dataLoading = true;
        this.dealService
          .getRegionByPostcode(this.dealDto.postcodeSearchString)
          .then((response) => {
            if (response.location != null) {
              this.dealDto.locations = response.location;
              this.showPostcodeErrorMessage = false;
            } else {
              this.postcodeErrorMsg = response.postCodeErrorMessage;
              this.showPostcodeErrorMessage = true;
              if (this.dealDto.locations) this.dealDto.locations = null;
            }
          })
          .finally(() => {
            this.dataLoading = false;
          });
      } else {
        this.postcodeErrorMsg = "At least one letter and one number must be entered e.g. SW1.";
        this.showPostcodeErrorMessage = true;
        if (this.dealDto.locations) this.dealDto.locations = null;
      }
    } else {
      if (this.dealDto.locations) this.dealDto.locations = null;
    }
  }

  onHasPostcodeChange() {
    if (!this.dealDto.hasPostcode) {
      this.showPostcodeErrorMessage = false;
      this.dealDto.postcodeSearchString = null;
      this.dealDto.locations = this.previouslySelectedLocation;
    } else {
      this.previouslySelectedLocation = this.dealDto.locations;
      this.dealDto.locations = null;
    }
  }

  isCriteriaFormInValid() {
    if (
      this.isSearchStarted ||
      this.multiPartForm1.$invalid ||
      this.dealDto.isFamilyInResidence == 1 ||
      this.dealDto.locations == null ||
      this.dealDto.locations <= 0 ||
      this.hasValidNetLoanRequiredValue() ||
      this.showPostcodeErrorMessage
    ) {
      if (this.isSearchStarted) {
        this.progressAmount = "100%";
      } else {
        this.progressAmount = "66%";
      }
      return true;
    } else {
      this.progressAmount = "100%";
      return false;
    }
  }

  commercialTypeChanged(productType: ProductTypeEnum) {
    this.progressSection = 1;
    this.getLoanInfoText(productType);
    this.dealDto = {} as CommercialDeal;
    this.dealDto = CommercialDealHelper.initialDataSetUp(this.dealDto, productType);
    if (this.$cookies.get("access_token")) {
      this.getOriginatorInfoForUser();
    } else {
      this.getOriginatorInfoForAnonymousUsers();
    }
    this.currentUseofBuildingOptions = this.selectListService.GetPropertyTypes(this.dealDto.productType);
    this.onLoanRepaymentTypeChange();

    this.hasPurchasecostChanged = false;
    if (!this.isLoggedInUser && this.isValidEnterprisePath()) {
      if (this.orgLinkId !== null && this.orgLinkId !== 0) {
        this.dealDto.organisationLinkId = this.orgLinkId;
      }

      this.logEvent("COMMERCIALCRITERIA-PAGE1");
    }
  }

  showBasedOnMainResidence() {
    return DealHelper.showBasedOnMainResidence(this.dealDto);
  }

  isFieldEmpty(fieldName, isEnum = false) {
    if (this.isSubmitted && this.dealDto) {
      const fieldValue = this.dealDto[fieldName];
      if (fieldName == "PlanningPermissionType") {
        if (fieldValue == null || fieldValue < 1) {
          return true;
        }
      }
      if (fieldValue == null || (isEnum && fieldValue === "0")) {
        return true;
      }
    }

    return false;
  }

  isFieldZero(fieldName) {
    if (this.isSubmitted && this.dealDto) {
      const fieldValue = this.dealDto[fieldName];
      if (fieldValue == null || fieldValue === "0" || fieldValue === 0) {
        return true;
      }
    }
    return false;
  }

  clickNextButton() {
    if (this.progressSection == 1) {
      if (!this.isLoggedInUser && this.isValidEnterprisePath()) {
        this.logEvent("COMMERCIALCRITERIA-PAGE2");
      }
      this.progressSection = 2;
    } else {
      if (!this.isLoggedInUser && this.isValidEnterprisePath()) {
        this.logEvent("COMMERCIALCRITERIA-PAGE3");
      }
      this.progressSection = 3;
    }
  }

  clickBackButton() {
    if (this.progressSection == 3) {
      if (!this.isLoggedInUser && this.isValidEnterprisePath()) {
        this.logEvent("COMMERCIALCRITERIA-PAGE2");
      }
      this.progressSection = 2;
    } else {
      if (!this.isLoggedInUser && this.isValidEnterprisePath()) {
        this.logEvent("COMMERCIALCRITERIA-PAGE1");
      }
      this.progressSection = 1;
    }
  }

  getLoanInfoText(productType) {
    switch (productType) {
      case ProductTypeEnum.CommercialInvestment:
        this.loanInfoText = "For landlords and investors that let to unrelated third parties";
        break;
      case ProductTypeEnum.CommercialOwnerOccupied:
        this.loanInfoText = "For businesses that own and operate out of their own premises";
        break;
      default:
        this.loanInfoText = "";
        break;
    }
  }
  async logEventWithoutDealData() {
    if (window.self == window.top) {
      if (sessionStorage.getItem("clientId")) {
        await this.eventLogClient.logPageLoad(
          "COMMERCIALCRITERIA",
          this.orgCode,
          "",
          "Client",
          this.orgLinkId ? this.orgLinkId : null,
          ProductTypeEnum.CommercialInvestment,
          "",
          this.dealDto.id,
          Number(sessionStorage.getItem("clientId")),
        );
      } else {
        await this.eventLogClient.logPageLoad(
          "COMMERCIALCRITERIA",
          this.orgCode,
          "",
          "Client",
          this.orgLinkId ? this.orgLinkId : null,
          ProductTypeEnum.CommercialInvestment,
          "",
          this.dealDto.id,
        );
      }
    } else {
      var clientId: number = null;
      clientId = Number(await this.organisationService.getData("clientId"));

      if (clientId) {
        await this.eventLogClient.logPageLoad(
          "COMMERCIALCRITERIA",
          this.orgCode,
          "",
          "Client",
          this.orgLinkId ? this.orgLinkId : null,
          ProductTypeEnum.CommercialInvestment,
          "",
          this.dealDto.id,
          clientId,
        );
      } else {
        await this.eventLogClient.logPageLoad(
          "COMMERCIALCRITERIA",
          this.orgCode,
          "",
          "Client",
          this.orgLinkId ? this.orgLinkId : null,
          ProductTypeEnum.CommercialInvestment,
          "",
          this.dealDto.id,
        );
      }
    }
  }

  getOriginatorInfoForUser() {
    if (this.isAdmin) {
      this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Admin;
      this.dealDto.sourceType = DealSourceTypeEnum.Application;
    } else if (this.isBroker && !this.isAdmin) {
      this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Broker;
    } else if (this.isBorrower && !this.isAdmin) {
      this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Borrower;
    } else if (this.isLender && !this.isAdmin) {
      this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Lender;
      this.dealDto.sourceType = DealSourceTypeEnum.Application;
    }

    if (window.self == window.top) {
      if (this.isLender) {
        this.userClient.getCurrentUserLender().then((response) => {
          this.dealDto.originatorLenderId = response;
        });
      }

      if (this.isBroker || this.isBorrower) {
        this.organisationService.getOrganisation().then((org) => {
          if (org != null) {
            if (org.id != 0) this.dealDto.originatorOrganisationId = org.id;
            this.dealDto.sourceType = org.isWhiteLabelled
              ? DealSourceTypeEnum.WhitelabelApplication
              : DealSourceTypeEnum.Application;
          }
        });
      }
    }
  }

  getOriginatorInfoForAnonymousUsers() {
    this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Borrower;

    if (window.self == window.top) {
      this.dealDto.sourceType = DealSourceTypeEnum.Enterprise;
    } else {
      this.dealDto.sourceType = this.isWidget
        ? DealSourceTypeEnum.WidgetEnterprise
        : DealSourceTypeEnum.IFrameEnterprise;
    }

    if (this.orgLinkId !== null && this.orgLinkId !== undefined) {
      const isEnterprise = window.self === window.top;
      const isManualUniqueLink = this.orgLinkSourceType === LinkSourceTypeEnum.Manual;
      const isEnterpriseUniqueLink = this.orgLinkSourceType === LinkSourceTypeEnum.Enterprise;

      if (isEnterprise) {
        this.dealDto.sourceType = isManualUniqueLink ? DealSourceTypeEnum.UniqueLink : DealSourceTypeEnum.Enterprise;
      } else if (this.isWidget) {
        this.dealDto.sourceType = isEnterpriseUniqueLink
          ? DealSourceTypeEnum.WidgetEnterprise
          : DealSourceTypeEnum.WidgetUniqueLink;
      } else {
        this.dealDto.sourceType = isManualUniqueLink
          ? DealSourceTypeEnum.IFrameUniqueLink
          : DealSourceTypeEnum.IFrameEnterprise;
      }
    }
  }

  postRetrieveProcessing(response) {
    this.dealDto = { ...response };
    this.getLoanInfoText(this.dealDto.productType);
    this.currentUseofBuildingOptions = this.selectListService.GetPropertyTypes(this.dealDto.productType);
    this.mortgageTerm = this.dealDto.loanTermReq / 12;
    this.snapshotDealDto = { ...response };
  }

  getRequiredRolesOptions() {
    return DealHelper.getRequiredRolesOptions();
  }

  isValidEnterprisePath() {
    const path = this.$location.path();
    const validPaths = ["/e/commercialcriteria", "/allloans", "/enterprise"];

    return validPaths.some((prefix) => path.startsWith(prefix));
  }

  goToBridgingCriteria() {
    if (
      this.$routeParams.uniqueId ||
      this.$location.path().startsWith("/allloans") ||
      this.$routeParams.context == "widget"
    ) {
      this.$scope.$emit("productFamilySelection", 2);
    } else if (this.isLoggedInUser) {
      this.$location.path("/bridgingcriteria");
    } else {
      this.$location.path(`/e/bridgingcriteria`);
    }
  }

  setShowVATBridgingModal() {
    this.showVATBridgingModal = true;
    this.eventLogClient.logPageLoad(
      "VATBRIDGING-CRITERIA-URL-CLICKED",
      "",
      (this.$rootScope as any)?.currentUser?.userName,
      "",
      null,
      this.dealDto.productType,
    );
  }
}
